import { useEffect, useState } from "react";
import { getUiMode, subscribeUiMode } from "./uiMode";

// The current interface ("classic" or "new"), re-rendering when the user switches.
export default function useUiMode() {
  const [mode, setMode] = useState(getUiMode);
  useEffect(() => subscribeUiMode(setMode), []);
  return mode;
}
